(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6006,687],{

/***/ 47443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 1196:
/***/ (function(module) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 5336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 41848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 21078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isFlattenable = __webpack_require__(37285);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 42118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIsNaN = __webpack_require__(62722),
    strictIndexOf = __webpack_require__(42351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 62722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 45652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arrayIncludes = __webpack_require__(47443),
    arrayIncludesWith = __webpack_require__(1196),
    cacheHas = __webpack_require__(74757),
    createSet = __webpack_require__(23593),
    setToArray = __webpack_require__(21814);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 54290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 23593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Set = __webpack_require__(58525),
    noop = __webpack_require__(50308),
    setToArray = __webpack_require__(21814);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 37285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 42351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 63105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    baseFilter = __webpack_require__(5336),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 29246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(81240),
    isObjectLike = __webpack_require__(37005);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 13880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833);

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),

/***/ 98913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    castFunction = __webpack_require__(54290),
    toInteger = __webpack_require__(40554);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),

/***/ 93386:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078),
    baseRest = __webpack_require__(5976),
    baseUniq = __webpack_require__(45652),
    isArrayLikeObject = __webpack_require__(29246);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),

/***/ 89463:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/one-pager-with-image-template-page",
      function () {
        return __webpack_require__(41299);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hamburger_menu_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/core/top-bar-new/hamburger-menu/hamburger-menu-component.scss.js



var StyledHamburgerMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ajo1f0"
})("width:28px;transform:rotate(0deg);cursor:pointer;z-index:", z_index/* SIDE_NAV */.gR + 1, ";margin-left:24px;margin-right:8px;height:36px;display:flex;.hamburger-menu-line{display:block;position:absolute;height:3px;width:100%;background-color:", colors/* default.black */.Z.black, ";border-radius:4px;opacity:1;left:0;transform:rotate(0deg);transition:all 0.2s ease-in-out;&:nth-child(1){top:8px;}&:nth-child(2),&:nth-child(3){top:17px;}&:nth-child(4){top:26px;}}&.open{.hamburger-menu-line{background-color:", colors/* default.black */.Z.black, ";&:nth-child(1){top:18px;width:0%;left:50%;}&:nth-child(2){transform:rotate(45deg);}&:nth-child(3){transform:rotate(-45deg);}&:nth-child(4){top:18px;width:0;left:50%;}}}");

;// CONCATENATED MODULE: ./components/core/top-bar-new/hamburger-menu/hamburger-menu-component.js










var HamburgerMenuComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HamburgerMenuComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HamburgerMenuComponent);
    function HamburgerMenuComponent(props) {
        (0,_class_call_check/* default */.Z)(this, HamburgerMenuComponent);
        var _this;
        _this = _super.call(this, props);
        _this.toggleOpenState = _this.toggleOpenState.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.toggleOpenState);
        return _this;
    }
    (0,_create_class/* default */.Z)(HamburgerMenuComponent, [
        {
            key: "toggleOpenState",
            value: function toggleOpenState() {
                var isOpen = this.props.isOpen;
                this.props.changeStateCallback(!isOpen);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, theme = _props.theme, isInScrollMode = _props.isInScrollMode, isOpen = _props.isOpen, translate = _props.translate;
                var scrollModeClass = isInScrollMode ? "scroll-mode" : "";
                var openMode = isOpen ? "open" : "";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHamburgerMenuComponent, {
                    className: "hamburger-menu ".concat(theme, " ").concat(scrollModeClass, " ").concat(openMode),
                    tabIndex: 0,
                    onClick: this.toggleOpenState,
                    onKeyDown: this.onKeyDown,
                    onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                    "aria-label": isOpen ? translate("header.closeMenu") : translate("header.openMenu"),
                    "aria-haspopup": "menu",
                    "aria-expanded": isOpen,
                    role: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        })
                    ]
                });
            }
        }
    ]);
    return HamburgerMenuComponent;
}(react.PureComponent);
HamburgerMenuComponent.defaultProps = {
    changeStateCallback: function() {},
    isInScrollMode: false,
    theme: "",
    isOpen: false
};
/* harmony default export */ var hamburger_menu_component = ((0,generic_config_context/* withGenericConfig */.P)(HamburgerMenuComponent));


/***/ }),

/***/ 44980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VideosGalleryComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/segments/videos-gallery/videos-gallery-component.scss.js

var StyledVideosGalleryComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eh299ux0"
})("width:100vw;padding:48px 0;.videos-gallery-title{margin-bottom:32px;font-size:calc(1vw + 0.875rem);line-height:48px;text-align:center;b{font-weight:500;}}.videos-list-wrapper{max-width:900px;margin:auto;display:flex;flex-wrap:wrap;justify-content:space-between;}");

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/thumbnails/video-thumbnail-item/video-thumbnail-item-component.scss.js


var StyledVideoThumbnailItemComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1lqb8yn0"
})("height:320px;width:280px;display:flex;flex-direction:column;margin-bottom:32px;border-radius:4px;box-shadow:0 2px 13px 0 rgba(206,206,206,0.5);cursor:pointer;transition:box-shadow 0.3s;.thumbnail-image-part{position:relative;height:200px;width:100%;.thumbnail-image{position:absolute;left:0;right:0;top:0;bottom:0;background-size:cover;background-position:center;transition:filter 0.3s;}.play-icon-container{position:absolute;bottom:12px;left:16px;svg{transition:transform 0.3s;}}}.thumbnail-text-part{flex:1;display:flex;flex-direction:column;justify-content:center;padding:0 16px;.video-title{font-size:1.375rem;line-height:32px;margin-bottom:8px;}.link-indicator{font-size:0.875rem;line-height:24px;text-decoration:underline;color:", colors/* default.brand-blue */.Z["brand-blue"], ";&:hover{color:", colors/* default.light-blue-hover */.Z["light-blue-hover"], ";}}}&:hover{box-shadow:0 10px 40px 0 rgba(192,192,192,0.4);.thumbnail-image-part{.thumbnail-image{filter:brightness(75%);}.play-icon-container{svg{transform:scale(1.1);}}}}");

;// CONCATENATED MODULE: ./static/svg/videos/video-play-button.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgVideoPlayButton = function SvgVideoPlayButton(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 70,
        height: 69,
        viewBox: "0 0 70 69"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#FFF",
        fillRule: "evenodd",
        d: "M34.85 68.789C15.927 68.789.586 53.469.586 34.572S15.926.356 34.851.356s34.266 15.319 34.266 34.216c0 18.898-15.342 34.217-34.266 34.217M27.873 46.03l20.01-9.991-20.01-9.99z"
    })));
};
/* harmony default export */ var video_play_button = (SvgVideoPlayButton);

// EXTERNAL MODULE: ./services/assets-service.js
var assets_service = __webpack_require__(57047);
;// CONCATENATED MODULE: ./components/core/thumbnails/video-thumbnail-item/video-thumbnail-item-component.js










var VideoThumbnailItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VideoThumbnailItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(VideoThumbnailItemComponent);
    function VideoThumbnailItemComponent(props) {
        (0,_class_call_check/* default */.Z)(this, VideoThumbnailItemComponent);
        var _this;
        _this = _super.call(this, props);
        _this.onClick = _this.onClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(VideoThumbnailItemComponent, [
        {
            key: "onClick",
            value: function onClick() {
                var _props = this.props, index = _props.index, onClick1 = _props.onClick;
                onClick1(index);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, thumbnailSrc = _props.thumbnailSrc;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledVideoThumbnailItemComponent, {
                    className: "video-thumbnail-item-component",
                    onClick: this.onClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "thumbnail-image-part",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "thumbnail-image",
                                    style: {
                                        backgroundImage: "url(".concat((0,assets_service/* getAssetPath */.K)(thumbnailSrc), ")")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "play-icon-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(video_play_button, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "thumbnail-text-part",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "video-title",
                                    dangerouslySetInnerHTML: {
                                        __html: title
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "link-indicator",
                                    children: "Watch video"
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return VideoThumbnailItemComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./components/core/youtube-video-modal/youtube-video-modal-component.js + 7 modules
var youtube_video_modal_component = __webpack_require__(60202);
// EXTERNAL MODULE: ./constants/youtube-modal.js
var youtube_modal = __webpack_require__(29238);
;// CONCATENATED MODULE: ./components/segments/videos-gallery/videos-gallery-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var VideosGalleryComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VideosGalleryComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(VideosGalleryComponent);
    function VideosGalleryComponent(props) {
        (0,_class_call_check/* default */.Z)(this, VideosGalleryComponent);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            showVideo: false,
            activeVideoIndex: null
        };
        _this.onVideoThumbnailClick = _this.onVideoThumbnailClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onCloseVideoModal = _this.onCloseVideoModal.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderVideoItem = _this.renderVideoItem.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(VideosGalleryComponent, [
        {
            key: "onVideoThumbnailClick",
            value: function onVideoThumbnailClick(activeVideoIndex) {
                this.setState({
                    showVideo: true,
                    activeVideoIndex: activeVideoIndex
                });
            }
        },
        {
            key: "onCloseVideoModal",
            value: function onCloseVideoModal() {
                this.setState({
                    showVideo: false
                });
            }
        },
        {
            key: "getCurrentVideo",
            value: function getCurrentVideo() {
                var videos = this.props.videos;
                var activeVideoIndex = this.state.activeVideoIndex;
                return videos[activeVideoIndex];
            }
        },
        {
            key: "renderVideoItem",
            value: function renderVideoItem(video, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoThumbnailItemComponent, _object_spread_props(_object_spread({
                    index: index
                }, video), {
                    onClick: this.onVideoThumbnailClick
                }), index);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, videos = _props.videos;
                var showVideo = this.state.showVideo;
                var activeVideo = this.getCurrentVideo();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledVideosGalleryComponent, {
                    className: "videos-gallery-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "videos-gallery-title",
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "videos-list-wrapper",
                            children: videos.map(this.renderVideoItem)
                        }),
                        showVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_modal_component/* default */.Z, {
                            videoId: activeVideo.videoId,
                            footerText: activeVideo.videoFooterText,
                            minHeight: 546,
                            isOpen: true,
                            opts: youtube_modal/* VIDEO_OPTS */.C,
                            onCloseModal: this.onCloseVideoModal
                        })
                    ]
                });
            }
        }
    ]);
    return VideosGalleryComponent;
}(react.PureComponent);



/***/ }),

/***/ 73098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MobileContentComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./components/core/one-pager/mobile-content/text-part/text-part-component.js + 3 modules
var text_part_component = __webpack_require__(57858);
// EXTERNAL MODULE: ./services/assets-service.js
var assets_service = __webpack_require__(57047);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/mobile-content/mobile-content-component.scss.js


var StyledMobileContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e133280y0"
})("height:calc(100% - 54px);display:flex;flex-direction:column;align-items:center;justify-content:center;.image-part-wrapper{max-width:70vw;margin-bottom:30vh;img{width:100%;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.image-part-wrapper{max-width:80vw;}}@media (max-width:", vp_sizes/* XXS */.Mp - 1, "px){margin-bottom:30vh;.image-part-wrapper{display:none;}}");

;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/mobile-content/mobile-content-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var MobileContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MobileContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MobileContentComponent);
    function MobileContentComponent() {
        (0,_class_call_check/* default */.Z)(this, MobileContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MobileContentComponent, [
        {
            key: "getTextColor",
            value: function getTextColor() {
                var backgroundColor = this.props.imageWithBackgroundPart.backgroundColor;
                return backgroundColor === "transparent" || backgroundColor === "white" ? "black" : "white";
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, textPart = _props.textPart, signupForm = _props.signupForm, collaborationWith = _props.collaborationWith, imageWithBackgroundPart = _props.imageWithBackgroundPart, isMobileOnly = _props.isMobileOnly;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileContentComponent, {
                    className: "mobile-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_component/* default */.Z, _object_spread_props(_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith,
                                customStyle: "mobile-clean-look",
                                color: "black",
                                isMobileCleanLook: true,
                                isMobileOnly: isMobileOnly
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            pictureClass: "image-part-wrapper",
                            src: (0,assets_service/* getAssetPath */.K)(imageWithBackgroundPart.src),
                            alt: imageWithBackgroundPart.alt
                        })
                    ]
                });
            }
        }
    ]);
    return MobileContentComponent;
}(react.PureComponent);

MobileContentComponent.defaultProps = {
    collaborationWith: {}
};


/***/ }),

/***/ 40119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OnePagerWithImageContentComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/one-pager/desktop-content/text-part/text-part-component.js + 5 modules
var text_part_component = __webpack_require__(63126);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/enhancements/decorators/background-triangle/background-triangle-component.scss.js



var StyledBackgroundTriangleComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e5hvm1d0"
})("position:absolute;border-bottom:100vh solid;border-left:18vw solid transparent;width:100%;top:0;right:0;&.straight-border{border-left:none;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){border-bottom:none;border-left:none;position:absolute;top:0;left:0;right:0;bottom:0;width:auto;z-index:", z_index/* HIDDEN */.A1, ";}");

;// CONCATENATED MODULE: ./components/enhancements/decorators/background-triangle/background-triangle-component.js









var BackgroundTriangleComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BackgroundTriangleComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BackgroundTriangleComponent);
    function BackgroundTriangleComponent() {
        (0,_class_call_check/* default */.Z)(this, BackgroundTriangleComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BackgroundTriangleComponent, [
        {
            key: "getInlineStyles",
            value: function getInlineStyles(borderColor, gradientColor) {
                var styles = {};
                if (borderColor) {
                    styles.borderBottomColor = colors/* default */.Z[borderColor];
                }
                if (gradientColor) {
                    var bgColor = colors/* default */.Z[gradientColor];
                    var whiteColor = colors/* default.white */.Z.white;
                    styles.background = "linear-gradient(172deg, ".concat(bgColor, " 0%, ").concat(bgColor, " calc(100vh / 1.3), ").concat(whiteColor, " calc(100vh / 1.29), ").concat(whiteColor, ")");
                }
                return styles;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, borderColor = _props.borderColor, gradientColor = _props.gradientColor, straightBorder = _props.straightBorder;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBackgroundTriangleComponent, {
                    className: classnames_default()("background-triangle", {
                        "straight-border": straightBorder
                    }),
                    style: this.getInlineStyles(borderColor, gradientColor)
                });
            }
        }
    ]);
    return BackgroundTriangleComponent;
}(react.PureComponent);

BackgroundTriangleComponent.defaultProps = {
    straightBorder: false
};

// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./services/assets-service.js
var assets_service = __webpack_require__(57047);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/desktop-content/desktop-content-component.scss.js



var StyledDesktopContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yorqsd0"
})("height:calc(100vh - 65px);overflow:hidden;display:flex;align-items:center;.text-part-wrapper{width:45vw;display:flex;align-items:center;padding:16px 24px 16px 80px;}.image-wrapper{width:calc(100vw - 45vw);height:100%;display:flex;justify-content:flex-end;align-items:center;position:relative;.image-part-wrapper{width:45vw;display:flex;position:relative;padding:4vw 4vw;z-index:", z_index/* LAYER_ONE */.KW, ";align-items:center;justify-content:center;img{max-width:100%;max-height:80vh;}&.align-bottom{align-self:flex-end;}&.align-top{align-self:flex-start;}}}&.straight-border{.text-part-wrapper{width:50vw;}.image-wrapper{width:calc(100vw - 50vw);.image-part-wrapper{width:50vw;}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.text-part-wrapper{padding:16px 0 16px 54px;}}");

;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/desktop-content/desktop-content-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var DesktopContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DesktopContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DesktopContentComponent);
    function DesktopContentComponent() {
        (0,_class_call_check/* default */.Z)(this, DesktopContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DesktopContentComponent, [
        {
            key: "getSegmentHeight",
            value: function getSegmentHeight() {
                var imageWithBackgroundPart = this.props.imageWithBackgroundPart;
                return imageWithBackgroundPart.imageSegmentHeight || "100vh";
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, textPart = _props.textPart, _signupForm = _props.signupForm, signupForm = _signupForm === void 0 ? {} : _signupForm, collaborationWith = _props.collaborationWith, imageWithBackgroundPart = _props.imageWithBackgroundPart;
                signupForm.focusOnLoad = true;
                var alignText = imageWithBackgroundPart.imageAlign;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDesktopContentComponent, {
                    className: classnames_default()("desktop-content-component", {
                        "straight-border": imageWithBackgroundPart.straightBorder
                    }),
                    style: {
                        height: "calc(".concat(this.getSegmentHeight(), " - 65px)")
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_component/* default */.Z, _object_spread_props(_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "image-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundTriangleComponent, {
                                    borderColor: imageWithBackgroundPart.backgroundColor,
                                    straightBorder: imageWithBackgroundPart.straightBorder
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("image-part-wrapper", alignText),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                        src: (0,assets_service/* getAssetPath */.K)(imageWithBackgroundPart.src),
                                        alt: imageWithBackgroundPart.alt
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return DesktopContentComponent;
}(react.PureComponent);
/* harmony default export */ var desktop_content_component = ((0,ab_tests_context/* withAbTests */.k)(DesktopContentComponent));

// EXTERNAL MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/mobile-content/mobile-content-component.js + 1 modules
var mobile_content_component = __webpack_require__(73098);
;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/one-pager-with-image-content-component.scss.js



var StyledOnePagerWithImageContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yv1r0r0"
})("width:100vw;display:flex;justify-content:space-around;.desktop-content-wrapper{width:100%;}.mobile-content-wrapper{display:none;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.desktop-content-wrapper{display:none;}.mobile-content-wrapper{display:flex;z-index:", z_index/* LAYER_ONE */.KW, ";justify-content:center;align-items:center;}}");

// EXTERNAL MODULE: ./components/segments/social-proof/social-proof-component.js + 1 modules
var social_proof_component = __webpack_require__(18925);
// EXTERNAL MODULE: ./components/segments/short-footer/short-footer-component.js
var short_footer_component = __webpack_require__(83234);
// EXTERNAL MODULE: ./components/segments/videos-gallery/videos-gallery-component.js + 4 modules
var videos_gallery_component = __webpack_require__(44980);
;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/one-pager-with-image-content-component.js




function one_pager_with_image_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function one_pager_with_image_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            one_pager_with_image_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}








var OnePagerWithImageContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OnePagerWithImageContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OnePagerWithImageContentComponent);
    function OnePagerWithImageContentComponent() {
        (0,_class_call_check/* default */.Z)(this, OnePagerWithImageContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(OnePagerWithImageContentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, videosGallery = _props.videosGallery, SocialProof = _props.SocialProof, ShortFooter = _props.ShortFooter;
                var showSocialProof = SocialProof.showSocialProof, socialProofContent = SocialProof.content;
                var showShortFooter = ShortFooter.showShortFooter, shortFooterContent = ShortFooter.content;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOnePagerWithImageContentComponent, {
                    className: "one-pager-with-image-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "desktop-content-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_content_component, one_pager_with_image_content_component_object_spread({}, this.props)),
                                showSocialProof && /*#__PURE__*/ (0,jsx_runtime.jsx)(social_proof_component/* default */.Z, one_pager_with_image_content_component_object_spread({}, socialProofContent)),
                                showShortFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer_component/* default */.Z, one_pager_with_image_content_component_object_spread({}, shortFooterContent)),
                                videosGallery && /*#__PURE__*/ (0,jsx_runtime.jsx)(videos_gallery_component/* default */.Z, one_pager_with_image_content_component_object_spread({}, videosGallery))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-content-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_content_component/* default */.Z, one_pager_with_image_content_component_object_spread({}, this.props))
                        })
                    ]
                });
            }
        }
    ]);
    return OnePagerWithImageContentComponent;
}(react.PureComponent);

OnePagerWithImageContentComponent.defaultProps = {
    textPart: {},
    imageWithBackgroundPart: {},
    collaborationWith: {},
    SocialProof: {},
    ShortFooter: {}
};


/***/ }),

/***/ 8264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OnePagerWithImageTemplate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_top_bar_new_top_bar_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21882);
/* harmony import */ var segments_desktop_footer_layouts_base_footer_base_footer_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44574);
/* harmony import */ var _components_addons_core_addons_core_addons_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48124);
/* harmony import */ var _components_templates_base_template__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77445);
/* harmony import */ var _one_pager_with_image_content_one_pager_with_image_content_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40119);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var OnePagerWithImageTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(OnePagerWithImageTemplate, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(OnePagerWithImageTemplate);
    function OnePagerWithImageTemplate(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, OnePagerWithImageTemplate);
        return _super.call(this, props);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(OnePagerWithImageTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, exitPopup = _props.exitPopup, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig;
                var socialButtons = pageConfig.socialButtons, footer = pageConfig.footer, topbar = pageConfig.topbar, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig;
                var topbarConfig = topbar || {};
                var footerConfig = footer || {};
                var showHeader = topbarConfig.showMenu || false;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_templates_base_template__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _object_spread_props(_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_top_bar_new_top_bar_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            loginTheme: topbarConfig.loginTheme,
                            menuTheme: topbarConfig.menuTheme,
                            showMenu: showHeader,
                            shortHeader: topbarConfig.shortHeader,
                            headerBackgroundColor: "white",
                            stickyMode: stickyMode,
                            allowSocialButtons: socialButtons && socialButtons.show,
                            socialButtonsColor: socialButtons && socialButtons.color,
                            mobileLogoTheme: "dark-theme",
                            topBanner: topBanner,
                            maxWidth: "100%"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_one_pager_with_image_content_one_pager_with_image_content_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, _object_spread({}, pageConfig))
                        }),
                        !footerConfig.preventFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "footer-wrapper",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(segments_desktop_footer_layouts_base_footer_base_footer_component__WEBPACK_IMPORTED_MODULE_3__["default"], {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_addons_core_addons_core_addons_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return OnePagerWithImageTemplate;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

OnePagerWithImageTemplate.defaultProps = {
    title: "monday.com",
    description: "",
    exitPopup: true
};


/***/ }),

/***/ 41299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ OnePagerWithImageTemplatePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_templates_one_pager_with_image_template_one_pager_with_image_template__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8264);
/* harmony import */ var _base_template_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49019);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var OnePagerWithImageTemplatePage = /*#__PURE__*/ function(BaseTemplatePage) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(OnePagerWithImageTemplatePage, BaseTemplatePage);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(OnePagerWithImageTemplatePage);
    function OnePagerWithImageTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, OnePagerWithImageTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(OnePagerWithImageTemplatePage, [
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                if (errorCode) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Error, {
                    statusCode: errorCode
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_one_pager_with_image_template_one_pager_with_image_template__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _object_spread({}, this.props));
            }
        }
    ]);
    return OnePagerWithImageTemplatePage;
}(_base_template_page__WEBPACK_IMPORTED_MODULE_2__["default"]);



/***/ }),

/***/ 14285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ long_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./components/core/short-footer/short-footer.js + 4 modules
var short_footer = __webpack_require__(69861);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js + 1 modules
var footer_category_component = __webpack_require__(70212);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.scss.js
var long_footer_scss = __webpack_require__(17619);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js + 10 modules
var footer_bottom_bar_component = __webpack_require__(46374);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/long-footer.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}











var Footer = function(props) {
    var translate = props.translate, localeId = props.localeId, abTests = props.abTests, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig;
    var LONG_FOOTER = "long";
    var renderShortFooter = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer/* default */.Z, _object_spread({}, props));
    };
    var renderLongFooter = function() {
        var getFullFooterForLocalized = true;
        var footerComponents = (0,localization_service/* getFooterComponents */.L8)(localeId, abTests, getFullFooterForLocalized, {});
        if (pageClusterConfig) {
            (0,cluster_config_service/* updateClusterFooterLinks */.R4)(pageClusterConfig, footerComponents, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
        }
        var MondayFooterLinks = footerComponents.MondayFooterLinks, OurTeamFooterLinksV2 = footerComponents.OurTeamFooterLinksV2, MoreByMondayFooterLinks = footerComponents.MoreByMondayFooterLinks, UseCasesFooterLinksV2 = footerComponents.UseCasesFooterLinksV2, ResourcesFooterLinks = footerComponents.ResourcesFooterLinks, ProductsFooterLinks = footerComponents.ProductsFooterLinks, FeaturesFooterLinks = footerComponents.FeaturesFooterLinks;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(long_footer_scss/* StyledFooter */.tc, {
            className: "footer-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "categories-container",
                            children: [
                                MondayFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(MondayFooterLinks.title),
                                        links: MondayFooterLinks.links,
                                        hasMondayLogoTitle: MondayFooterLinks.hasMondayLogoTitle
                                    })
                                }),
                                FeaturesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container features",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(FeaturesFooterLinks.title),
                                        links: FeaturesFooterLinks.links
                                    })
                                }),
                                ProductsFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container products",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "categories-colmmn-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: ProductsFooterLinks.type,
                                                title: translate(ProductsFooterLinks.title),
                                                links: ProductsFooterLinks.links
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: MoreByMondayFooterLinks.type,
                                                title: translate(MoreByMondayFooterLinks.title),
                                                links: MoreByMondayFooterLinks.links
                                            })
                                        ]
                                    })
                                }),
                                UseCasesFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(UseCasesFooterLinksV2.title),
                                        links: UseCasesFooterLinksV2.links
                                    })
                                }),
                                OurTeamFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: OurTeamFooterLinksV2.type,
                                        title: translate(OurTeamFooterLinksV2.title),
                                        links: OurTeamFooterLinksV2.links
                                    })
                                }),
                                ResourcesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: ResourcesFooterLinks.type,
                                        title: translate(ResourcesFooterLinks.title),
                                        links: ResourcesFooterLinks.links
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_bar_component/* default */.Z, {
                    SocialFooterLinks: links/* SocialFooterLinks */.Ff7,
                    footerType: LONG_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledDesktopFooterContainer */.w2, {
                className: "footer-desktop-wrapper",
                children: renderLongFooter()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledMobileFooterContainer */.qJ, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
/* harmony default export */ var long_footer = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(Footer)));
Footer.defaultProps = default_props;


/***/ }),

/***/ 53021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ slim_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./components/core/short-footer/short-footer.js + 4 modules
var short_footer = __webpack_require__(69861);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js + 1 modules
var footer_category_component = __webpack_require__(70212);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.scss.js
var long_footer_scss = __webpack_require__(17619);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js + 10 modules
var footer_bottom_bar_component = __webpack_require__(46374);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/core-components/slim-footer/default-props.js
/* harmony default export */ var default_props = ({});

;// CONCATENATED MODULE: ./segments/desktop/core-components/slim-footer/slim-footer.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}











var SlimFooter = function(props) {
    var translate = props.translate, localeId = props.localeId, abTests = props.abTests, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig;
    var SLIM_FOOTER = "slim";
    var renderShortFooter = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer/* default */.Z, _object_spread({}, props));
    };
    var renderSlimFooter = function() {
        var getFullFooterForLocalized = true;
        var footerComponents = (0,localization_service/* getFooterComponents */.L8)(localeId, abTests, getFullFooterForLocalized, {
            pageClusterConfig: pageClusterConfig,
            useProductMiniSiteConfig: useProductMiniSiteConfig
        });
        var SlimFooterLinks = footerComponents.SlimFooterLinks;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(long_footer_scss/* StyledFooter */.tc, {
            className: classnames_default()("footer-container", "slim-footer"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "categories-container",
                            children: SlimFooterLinks.map(function(column, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: column.type,
                                        links: column.links,
                                        hasMondayLogoTitle: index === 0
                                    })
                                });
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_bar_component/* default */.Z, {
                    SocialFooterLinks: links/* SocialFooterLinks */.Ff7,
                    footerType: SLIM_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledDesktopFooterContainer */.w2, {
                className: "footer-desktop-wrapper",
                children: renderSlimFooter()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledMobileFooterContainer */.qJ, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
/* harmony default export */ var slim_footer = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(SlimFooter)));
SlimFooter.defaultProps = default_props;


/***/ }),

/***/ 44574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ base_footer_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.js + 1 modules
var long_footer = __webpack_require__(14285);
// EXTERNAL MODULE: ./segments/desktop/core-components/slim-footer/slim-footer.js + 1 modules
var slim_footer = __webpack_require__(53021);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/footer-consts.js
var footer_consts = __webpack_require__(99633);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/default-props.js
var default_props = __webpack_require__(96564);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-component.scss.js

var StyledBaseFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1cyjyh50"
})();

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/base-footer/base-footer-component.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}






var BaseFooterComponent = function(props) {
    var _obj;
    var Footer = (_obj = {}, (0,_define_property/* default */.Z)(_obj, footer_consts/* LONG */.F, long_footer/* default */.Z), (0,_define_property/* default */.Z)(_obj, footer_consts/* SLIM */.z, slim_footer/* default */.Z), _obj)[props.footer_type] || slim_footer/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBaseFooterComponent, {
        className: "base-footer-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, _object_spread({}, props))
    });
};
BaseFooterComponent.defaultProps = default_props/* default */.Z;
/* harmony default export */ var base_footer_component = (BaseFooterComponent);


/***/ }),

/***/ 96564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _footer_consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99633);

/* harmony default export */ __webpack_exports__["Z"] = ({
    footer_type: _footer_consts__WEBPACK_IMPORTED_MODULE_0__/* .SLIM */ .z
});


/***/ }),

/***/ 99633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ LONG; },
/* harmony export */   "z": function() { return /* binding */ SLIM; }
/* harmony export */ });
var SLIM = "slim";
var LONG = "long";


/***/ }),

/***/ 57047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getAssetPath; }
/* harmony export */ });
/* harmony import */ var services_environment_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56274);
/* harmony import */ var services_environment_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(services_environment_service__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var process = __webpack_require__(83454);

var isStorybook = process.env.IS_STORYBOOK === "true";
var getStagingAssetPath = function(src) {
    return "https://mondaystaging.com" + src;
};
var isLocalAssetPath = function(src) {
    return (services_environment_service__WEBPACK_IMPORTED_MODULE_0__.isDevelopment || isStorybook) && src && src.startsWith("/static/");
};
var getAssetPath = function(src) {
    return isLocalAssetPath(src) ? getStagingAssetPath(src) : src;
};


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ }),

/***/ 5499:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(this, function(require,exports,module) {

return function ouibounce(el, custom_config) {
  "use strict";

  var config     = custom_config || {},
    aggressive   = config.aggressive || false,
    sensitivity  = setDefault(config.sensitivity, 20),
    timer        = setDefault(config.timer, 1000),
    delay        = setDefault(config.delay, 0),
    callback     = config.callback || function() {},
    cookieExpire = setDefaultCookieExpire(config.cookieExpire) || '',
    cookieDomain = config.cookieDomain ? ';domain=' + config.cookieDomain : '',
    cookieName   = config.cookieName ? config.cookieName : 'viewedOuibounceModal',
    sitewide     = config.sitewide === true ? ';path=/' : '',
    _delayTimer  = null,
    _html        = document.documentElement;

  function setDefault(_property, _default) {
    return typeof _property === 'undefined' ? _default : _property;
  }

  function setDefaultCookieExpire(days) {
    // transform days to milliseconds
    var ms = days*24*60*60*1000;

    var date = new Date();
    date.setTime(date.getTime() + ms);

    return "; expires=" + date.toUTCString();
  }

  setTimeout(attachOuiBounce, timer);
  function attachOuiBounce() {
    if (isDisabled()) { return; }

    _html.addEventListener('mouseleave', handleMouseleave);
    _html.addEventListener('mouseenter', handleMouseenter);
    _html.addEventListener('keydown', handleKeydown);
  }

  function handleMouseleave(e) {
    if (e.clientY > sensitivity) { return; }

    _delayTimer = setTimeout(fire, delay);
  }

  function handleMouseenter() {
    if (_delayTimer) {
      clearTimeout(_delayTimer);
      _delayTimer = null;
    }
  }

  var disableKeydown = false;
  function handleKeydown(e) {
    if (disableKeydown) { return; }
    else if(!e.metaKey || e.keyCode !== 76) { return; }

    disableKeydown = true;
    _delayTimer = setTimeout(fire, delay);
  }

  function checkCookieValue(cookieName, value) {
    return parseCookies()[cookieName] === value;
  }

  function parseCookies() {
    // cookies are separated by '; '
    var cookies = document.cookie.split('; ');

    var ret = {};
    for (var i = cookies.length - 1; i >= 0; i--) {
      var el = cookies[i].split('=');
      ret[el[0]] = el[1];
    }
    return ret;
  }

  function isDisabled() {
    return checkCookieValue(cookieName, 'true') && !aggressive;
  }

  // You can use ouibounce without passing an element
  // https://github.com/carlsednaoui/ouibounce/issues/30
  function fire() {
    if (isDisabled()) { return; }

    if (el) { el.style.display = 'block'; }

    callback();
    disable();
  }

  function disable(custom_options) {
    var options = custom_options || {};

    // you can pass a specific cookie expiration when using the OuiBounce API
    // ex: _ouiBounce.disable({ cookieExpire: 5 });
    if (typeof options.cookieExpire !== 'undefined') {
      cookieExpire = setDefaultCookieExpire(options.cookieExpire);
    }

    // you can pass use sitewide cookies too
    // ex: _ouiBounce.disable({ cookieExpire: 5, sitewide: true });
    if (options.sitewide === true) {
      sitewide = ';path=/';
    }

    // you can pass a domain string when the cookie should be read subdomain-wise
    // ex: _ouiBounce.disable({ cookieDomain: '.example.com' });
    if (typeof options.cookieDomain !== 'undefined') {
      cookieDomain = ';domain=' + options.cookieDomain;
    }

    if (typeof options.cookieName !== 'undefined') {
      cookieName = options.cookieName;
    }

    document.cookie = cookieName + '=true' + cookieExpire + cookieDomain + sitewide;

    // remove listeners
    _html.removeEventListener('mouseleave', handleMouseleave);
    _html.removeEventListener('mouseenter', handleMouseenter);
    _html.removeEventListener('keydown', handleKeydown);
  }

  return {
    fire: fire,
    disable: disable,
    isDisabled: isDisabled
  };
}

/*exported ouibounce */
;

}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5961,296,4102,2448,7883,6250,4800,9861,627,6720,7445,2727,9112,8124,1882,9019,3971,8689,9774,2888,179], function() { return __webpack_exec__(89463); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);